module.exports = __webpack_public_path__ + "static/media/employAccept.a13ba6fb.svg";